export default __webpack_public_path__ + "static/media/rabbitmq.3e443da4.svg";